import { formatDate } from "./roconConstants";

export const siteDetails = (sites) => {
  return {
    siteName: sites?.siteName,
    domainName: sites?.domainName,
    siteId: sites?.siteId,
    features:
      sites?.featuresUsageRes?.map((item) => ({
        limit: parseInt(item?.limitOrAvailablity),
        type: item?.type,
        used: parseInt(item?.used),
      })) || [],
    ipAddress: sites?.ipAddress,
    instanceIp: sites?.dedicatedInstanceDetails?.ipAddress,
    instanceWp: sites?.dedicatedInstanceDetails?.wpVersion,
    instancePhp: sites?.dedicatedInstanceDetails?.phpVersion,
    installType: sites?.installType,
    phpVersion: sites?.phpVersion,
    sftp: sites?.sftpDetails,
    staging:
      sites?.stagingDomainsList?.map((item) => ({
        environment: item?.environment,
        domain: item?.domainName,
        wp: item?.wpVersion,
        wpUserId: item?.wpUserId,
        wpCache: item?.wpCache,
        wpDebug: item?.wpDebug,
        latestWp: item?.wpLatestVersion,
      })) || [],
    imagePath: sites?.imagePath,
    files:
      sites?.files?.files?.map((item) => ({
        createdAt: formatDate(item?.createdAt),
        name: item?.name,
        size: item?.size,
      })) || [],
    folders:
      sites?.files?.folders?.map((item) => ({
        createdAt: formatDate(item?.createdAt),
        name: item?.name,
        size: item?.size,
      })) || [],
    wafStatus: sites?.waf,
    domain:
      sites?.siteDomainsRes?.map((item) => ({
        id: item?.domainId,
        name: item?.domainName,
        primary: item?.primarySw,
        purchased: item?.purchased,
        expiration: item?.sslExpiration,
        status: item?.status,
      })) || [],
    alerts:
      sites?.alertDetails?.map((item) => ({
        alertType: item?.alertType,
        dateTime: item?.date,
        downloadLogFile: item?.logFilePath,
        severity: item?.severity,
      })) || [],
    performanceSite: sites?.addons?.map((addon) => addon.addonName) || [],
    wafUpdateStatus: sites?.wafUpdateStatus,
    domainStatus: sites?.domainStatus,
  };
};

export const staging = (sites) => {
  return sites?.stagingDomainsList?.find(
    (item) => item?.environment === "STAGING",
  );
};

export const prod = (sites) => {
  return sites?.stagingDomainsList?.find(
    (item) => item?.environment === "LIVE",
  );
};

// Dev Tools Constants
export const devToolsConst = {
  HEADER: "Dev Tools",
  ERROR_MSG:
    "Requires at least 8 characters with one capital letter, one numeric character, and one special character",
  SFTP_HEADER: "Add SFTP user to LIVE",
  SFTP_SUB_HEADER:
    "Please provide the user information below to set up SFTP access. Share these login details with anyone requiring access to your environment. Remember to create separate SFTP logins for each WordPress environment on your account",
  WAF_HEADER: "Web Application Firewall",
  WAF_SUB_HEADER: "You are one step away",
  NA: "N/A",
  WAF_CONFIRM: "Please confirm if you are sure?",
  HOST: `${process.env.REACT_APP_SFTP}.${process.env.REACT_APP_TEMP_DOMAIN}`,

  // Popups
  POPUP_TYPE_INFO: "info",
  POPUP_TITLE: "This is a configuration action",
  POPUP_SUB_TITLE: "Are you sure you want to proceed?",
  YES: "Yes",
  NO: "No",
  OK: "OK",

  // Buttons
  CONFIRM: "confirm",
  ADD: "Add SFTP User",

  // Input
  INPUT_TITLE: "Username",
  NONE: "none",

  //Header Props
  LABEL: "SFTP Details",
  TITLE_COLOR: "#12334",
  CREATE_BUTTON: "Create SFTP User",
};

export const getStagingEnv = (staging, env) =>
  staging?.find((s) => s.environment === env)?.environment || "N/A";
